import { AdvanceTable } from '@aibees/shared/features';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(AdvanceTable)`
  padding: 0;
  background-color: ${(p) => p.theme.palette.common.white};
  height: fit-content;

  max-width: 100%;
  table {
    width: 100%;
    td,
    th {
      width: fit-content !important ;
      overflow: hidden;
      text-overflow: hidden;
      white-space: nowrap;
      font-weight: 500;
      font-size: ${(p) => p.theme.typography.body4.fontSize};
      color: ${(p) => p.theme.palette.grey[800]};
    }

    th {
      padding: ${(p) => p.theme.spacing(0, 1)} !important;
    }

    th:first-of-type,
    th:last-of-type,
    td:first-of-type,
    td:last-of-type {
      border-radius: 0px !important;
    }

    tr:last-child td {
      border-bottom: none !important;
    }
  }

  thead {
    height: 32px;
    background: ${(p) => p.theme.palette.grey[100]} !important;
  }

  tr {
    height: 32px;
  }

  td {
    background: ${(p) => p.theme.palette.common.white} !important;
  }

  .Table {
    background-color: ${(p) => p.theme.palette.common.white} !important;
    border-radius: ${(p) => p.theme.spacing(0.5)} !important;
    border: 1px solid ${(p) => p.theme.palette.grey[300]} !important;
  }
`;
